export default "__VITE_ASSET__Dn2FDr6V__"